<!--suppress AngularNgOptimizedImage -->
<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[{ label: 'Medicos', link: '/doctor-list' }]">
      </app-breadcrumb>
    </div>

    <app-top-widgets/>

    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="materialTableHeader">
            <div class="left">
              <ul class="header-buttons-left ms-0">
                <li class="tbl-search-box">
                  <label><i class="material-icons search-icon">search</i></label>
                  <input #filter
                         aria-autocomplete="none"
                         aria-label="Search box" autocomplete="nope" class="browser-default search-field"
                         placeholder="BUSCAR"
                         type="text" data-tour="doctor-search">
                </li>
              </ul>
            </div>
            <div class="right">
              <ul class="tbl-export-btn">
                <li class="tbl-header-btn">
                  <div class="m-l-10" matTooltip="CREAR">
                    <button (click)="addNew()" color="primary" mat-mini-fab data-tour="doctor-create">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </li>
                <li class="tbl-header-btn">
                  <div class="m-l-10" matTooltip="RECARGAR">
                    <button (click)="refresh()" color="primary" mat-mini-fab>
                      <mat-icon>refresh</mat-icon>
                    </button>
                  </div>
                </li>
                <li>
                  <div class="export-button m-l-10" matTooltip="EXCEL">
                    <img (click)="exportExcel()" alt="" src="assets/images/icons/xlsx.png"/>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="body overflow-auto">
            <div class="responsive_table" data-tour="doctor-table">
              <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

                <ng-container matColumnDef="idMedico">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.idMedico}}">{{ row.idMedico }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="nombre">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</mat-header-cell>
                  <mat-cell (click)="goToProfile(row)" *matCellDef="let row" matTooltip="{{row.nombres}}" data-tour="doctor-name-cell"><span
                    class="mobile-label">Nombres:</span>
                    <div class="block">
                      <span class="prop_one">{{ row.nombres }}</span>
                      <span class="prop_two">{{ row.horario }}</span>
                      <span class="prop_two">TELEFONO: {{ row.movil | formatMobile }}</span>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="especialidad">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>ESPECIALIDAD</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.especialidad}}"><span class="mobile-label">Especialidad:</span>
                    <div class="block">
                      <span class="prop_two">{{ row.especialidad ? row.especialidad : 'Sin especialidad' }}</span>
                      <span class="prop_two">{{ row.cedulaEspecialidad ? row.cedulaEspecialidad : '' }}</span>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="cedula">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>CEDULA GENERAL</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.cedulaGeneral}}"><span
                    class="mobile-label">Cedulas:</span>
                    <div class="block">
                      <span class="prop_two">{{ row.cedulaGeneral }}</span>
                      <span class="prop_two">{{ row.universidad }}</span>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="email">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>CORREO</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.email}}">
                    <span class="mobile-label">Correo:</span>
                    <a href="mailto:{{row.email}}">{{ row.email }}</a>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="asentamiento">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>DIRECCION</mat-header-cell>
                  <mat-cell *matCellDef="let row" matTooltip="{{row.asentamiento}}"><span class="mobile-label">Asentamiento:</span>
                    <div class="block">
                      <span class="prop_two">{{ row.domicilio }}</span>
                      <span class="prop_two">{{ row.asentamiento }}, {{ row.codigoPostal }}</span>
                      <span class="prop_two">{{ row.municipio }}, {{ row.estado }}</span>
                    </div>
                  </mat-cell>
                </ng-container>

                <!-- actions -->
                <ng-container matColumnDef="acciones">
                  <mat-header-cell *matHeaderCellDef class="pr-0">ACCIONES</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i=index;" class="pr-0">
                    <button (click)="$event.stopPropagation(); editCall(row)" class="tbl-action-btn"
                            mat-icon-button>
                      <app-feather-icons [class]="'tbl-fav-edit'" [icon]="'edit'"></app-feather-icons>
                    </button>
                    <button (click)="$event.stopPropagation(); deleteItem(row)" class="tbl-action-btn"
                            mat-icon-button *ngIf="isAdmin">
                      <app-feather-icons [class]="'tbl-fav-delete'" [icon]="'trash-2'"></app-feather-icons>
                    </button>
                  </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <!-- <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row> -->
                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
              </table>
              <!-- Loading spinner -->
              @if (data?.isTblLoading) {
                <div class="tbl-spinner">
                  <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
                  </mat-progress-spinner>
                </div>
              }
              @if (!data?.isTblLoading) {
                <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
                  SIN RESULTADOS
                </div>
              }
              <mat-paginator [length]="dataSource.filteredData.length" [pageIndex]="0"
                             [pageSizeOptions]="[5, 10, 25, 100]"
                             [pageSize]="10">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

